import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./draw-remove-all.html?ngResource";
import __NG_CLI_RESOURCE__1 from "../../../esri-map/esri-map.component.scss?ngResource";
import { ChangeDetectionStrategy, Component, Injectable } from "@angular/core";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";
export let DrawToolRemoveComponent = class DrawToolRemoveComponent {
    buffEnabled = true;
    constructor() {
    }
    addRemoveAllButton(mapView, graphicsLayer, bufferLayer, sketch) {
        const btnRemoveAll = document.getElementsByTagName("app-tool-remove")[0];
        btnRemoveAll.addEventListener("click", () => {
            if (mapView.map.findLayerById(graphicsLayer.id))
                mapView.map.findLayerById(graphicsLayer.id).removeAll();
            if (mapView.map.findLayerById(bufferLayer.id))
                mapView.map.findLayerById(bufferLayer.id).removeAll();
        });
        sketch.container.appendChild(btnRemoveAll);
        reactiveUtils.when(() => mapView?.ready === true, () => {
            const section = document.querySelectorAll(".esri-sketch__section");
            if (section[2]) {
                section[2].append(btnRemoveAll);
            }
        });
    }
    static ctorParameters = () => [];
};
DrawToolRemoveComponent = __decorate([
    Component({
        selector: "app-tool-remove",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    Injectable({
        providedIn: "root"
    })
], DrawToolRemoveComponent);
